import { formatHeat } from "@/utils/timeline";

interface HeatMeterProps {
  heat: number;
  max: number;
  comments?: number;
}

export default function HeatMeter({ heat, max, comments }: HeatMeterProps) {
  const percent = Math.max(6, Math.min(100, Math.round((heat / max) * 100)));
  return (
    <div className="flex items-center gap-3">
      <span className="inline-flex items-center gap-1 text-xs text-primary-700 whitespace-nowrap">
        <i className="ri-fire-line" />
        热度 {formatHeat(heat)}
      </span>
      <span className="hidden sm:block h-1.5 flex-1 rounded-full bg-background-200 overflow-hidden">
        <span
          className="block h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-500"
          style={{ width: `${percent}%` }}
        />
      </span>
      {typeof comments === "number" ? (
        <span className="inline-flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
          <i className="ri-chat-3-line" />
          {comments}
        </span>
      ) : null}
    </div>
  );
}